/*
  favoritos.js
  - Modulo global: gestiona localStorage de handles favoritos.
  - Wire up del corazon en product-card: toggle on click.
  - Render del grid en /pages/favoritos (cuando existe [data-favoritos-grid]).
*/

(function () {
  var STORAGE_KEY = 'av_favoritos';

  function getFavoritos() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function saveFavoritos(arr) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
    } catch (e) {}
    window.dispatchEvent(new CustomEvent('favoritos:change', { detail: { handles: arr } }));
  }

  function toggleHandle(handle) {
    if (!handle) return false;
    var arr = getFavoritos();
    var idx = arr.indexOf(handle);
    var nowActive;
    if (idx > -1) {
      arr.splice(idx, 1);
      nowActive = false;
    } else {
      arr.push(handle);
      nowActive = true;
    }
    saveFavoritos(arr);
    return nowActive;
  }

  /* === Wire up corazon en product-card (cualquier pagina) === */
  function bindCardHearts() {
    document.querySelectorAll('[data-product-card]:not([data-fav-bound])').forEach(function (card) {
      card.setAttribute('data-fav-bound', '1');
      var heart = card.querySelector('.product-card__wishlist');
      var handle = heart && heart.getAttribute('data-product-handle');
      if (!heart || !handle) return;

      // Initial active state
      if (getFavoritos().indexOf(handle) > -1) heart.classList.add('is-active');

      heart.addEventListener('click', function (e) {
        e.preventDefault();
        var active = toggleHandle(handle);
        heart.classList.toggle('is-active', active);
      });
    });
  }

  /* === Render grid en /pages/favoritos === */
  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  function formatMoney(cents) {
    var v = (cents / 100).toFixed(2);
    return '$' + v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function cardHTML(p, handle) {
    var img = p.featured_image || (p.images && p.images[0]);
    var imgUrl = img ? (typeof img === 'string' ? img : img.src) : '';
    var price = p.price;
    var compare = p.compare_at_price;
    var onSale = compare && compare > price;

    return ''
      + '<article class="product-card" data-product-card>'
        + '<div class="product-card__media-wrap">'
          + '<button type="button" class="product-card__wishlist is-active" aria-label="Quitar de favoritos" data-product-handle="' + escapeHtml(handle) + '">'
            + '<svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
              + '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>'
            + '</svg>'
          + '</button>'
          + '<a href="' + escapeHtml(p.url) + '" class="product-card__media">'
            + (imgUrl ? '<img src="' + escapeHtml(imgUrl) + '" alt="' + escapeHtml(p.title) + '" class="product-card__img product-card__img--primary" loading="lazy">' : '')
          + '</a>'
        + '</div>'
        + '<div class="product-card__info">'
          + '<h3 class="product-card__title"><a href="' + escapeHtml(p.url) + '">' + escapeHtml(p.title) + '</a></h3>'
          + '<div class="product-card__price">'
            + (onSale
              ? '<span class="product-card__price-sale">' + formatMoney(price) + '</span><s class="product-card__price-compare">' + formatMoney(compare) + '</s>'
              : '<span class="product-card__price-regular">' + formatMoney(price) + '</span>')
          + '</div>'
        + '</div>'
      + '</article>';
  }

  function renderFavGrid() {
    var grid = document.querySelector('[data-favoritos-grid]');
    var empty = document.querySelector('[data-favoritos-empty]');
    var loading = document.querySelector('[data-favoritos-loading]');
    if (!grid || !empty || !loading) return;

    var handles = getFavoritos();
    if (handles.length === 0) {
      loading.hidden = true;
      grid.hidden = true;
      empty.hidden = false;
      return;
    }

    loading.hidden = false;
    empty.hidden = true;
    grid.hidden = true;

    var promises = handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return p ? { handle: h, product: p } : null; })
        .catch(function () { return null; });
    });

    Promise.all(promises).then(function (results) {
      loading.hidden = true;
      var valid = results.filter(Boolean);
      // Prune handles invalidos del localStorage
      var validHandles = valid.map(function (r) { return r.handle; });
      if (validHandles.length !== handles.length) saveFavoritos(validHandles);

      if (valid.length === 0) {
        empty.hidden = false;
        return;
      }

      grid.innerHTML = valid.map(function (r) { return cardHTML(r.product, r.handle); }).join('');
      grid.hidden = false;
      bindCardHearts();

      // Cuando se quita un favorito desde aqui, remover la card del grid
      grid.addEventListener('click', function (e) {
        var heart = e.target.closest('.product-card__wishlist');
        if (!heart) return;
        var card = heart.closest('[data-product-card]');
        if (card && !heart.classList.contains('is-active')) {
          // Remover visualmente con un fadeout suave
          card.style.transition = 'opacity 200ms ease, transform 200ms ease';
          card.style.opacity = '0';
          card.style.transform = 'scale(0.96)';
          setTimeout(function () {
            card.remove();
            if (!grid.querySelector('[data-product-card]')) {
              grid.hidden = true;
              empty.hidden = false;
            }
          }, 220);
        }
      }, { once: true });
    });
  }

  /* === Init === */
  function init() {
    bindCardHearts();
    renderFavGrid();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-bind cuando se cargan productos dinamicamente (ej. quick-view o carruseles)
  document.addEventListener('shopify:section:load', bindCardHearts);

  // Sincronizar entre pestañas
  window.addEventListener('storage', function (e) {
    if (e.key !== STORAGE_KEY) return;
    document.querySelectorAll('.product-card__wishlist[data-product-handle]').forEach(function (h) {
      var handle = h.getAttribute('data-product-handle');
      h.classList.toggle('is-active', getFavoritos().indexOf(handle) > -1);
    });
  });
})();